<template>
    <div class="NotificationBox" :class="{active: show}">
        <div class="indicator"></div>
        <v-layout row wrap>
            <v-flex style="min-width: 50%">
                <div :class="`text-xs-center py-2 tab_filter_btn_wrapper ${typeFilter === 'admin_assign_support'?'tab_filter_btn_wrapper_activate':''}`"
                     @click="typeFilter = (typeFilter === 'admin_assign_support' ? null : 'admin_assign_support')">
                    <v-tooltip right nudge-left="8" nudge-bottom="24" open-delay="0">
                        <span slot="activator" :class="`tab_chats_filter_text ${typeFilter === 'admin_assign_support'?'tab_chats_filter_activate':''} tab_filter_btn_badge`">
                            <div style="display: inline-block" class="notification-circle active admin_assign_support"></div>
                            <div style="display: inline-block" >{{ $t("assignToMe") }}</div>
                        </span>
                        <span>{{ $t('assignToMe') }}</span>
                    </v-tooltip>
                </div>
            </v-flex>
            <v-flex style="min-width: 50%">
                <div :class="`text-xs-center py-2 tab_filter_btn_wrapper ${typeFilter === 'user_request_support'?'tab_filter_btn_wrapper_activate':''}`"
                     @click="typeFilter = (typeFilter === 'user_request_support' ? null : 'user_request_support')">
                    <v-tooltip right nudge-left="8" nudge-bottom="24" open-delay="0">
                            <span slot="activator" :class="`tab_chats_filter_text ${typeFilter === 'user_request_support'?'tab_chats_filter_activate':''} tab_filter_btn_badge`">
                                <div style="display: inline-block" class="notification-circle active user_request_support"></div>
                                <div style="display: inline-block" >{{ $t("requestSupport") }}</div>
                            </span>
                        <span>{{ $t('notifyRequestSupport') }}</span>
                    </v-tooltip>
                </div>
            </v-flex>
            <v-flex style="min-width: 50%">
                <div :class="`text-xs-center py-2 tab_filter_btn_wrapper ${typeFilter === 'warning'?'tab_filter_btn_wrapper_activate':''}`"
                     @click="typeFilter = (typeFilter === 'warning' ? null : 'warning')">
                    <v-tooltip right nudge-left="8" nudge-bottom="24" open-delay="0">
                            <span slot="activator" :class="`tab_chats_filter_text ${typeFilter === 'warning'?'tab_chats_filter_activate':''} tab_filter_btn_badge`">
                                <div style="display: inline-block" class="notification-circle active notify-warning"></div>
                                <div style="display: inline-block" >{{ $t("warning")|capitalize }}</div>
                            </span>
                        <span>{{ $t('warning')|capitalize }}</span>
                    </v-tooltip>
                </div>
            </v-flex>
        </v-layout>
        <div class="item-list scroll-thin">
            <div v-for="(notification, i) in notifies_data" :key="i" class="notification-item">
                <div class="notification-circle" :class="{active: !notification.read_status, big: notification.count > 1, [notification.type]: true}">
                    <v-tooltip right nudge-right="-6" nudge-bottom="0" open-delay="0" :disabled="notification.count <= 9">
                        <span v-if="notification.count > 1" slot="activator">
                            {{parseCount(notification.count)}}
                        </span>
                        <span>{{notification.count}}</span>
                    </v-tooltip>
                </div>
                <div style="flex: 1 1 1px;">
                    <div class="notification-text" v-html="format_notify_message(notification).formatted_msg"></div>
                    <v-layout align-center>
                        <span class="notification-time">
                            {{ notification.created_time | moment("DD/MM/YYYY HH:mm") }}
                        </span>
                        <v-spacer></v-spacer>
                        <img src="/icon/chat.svg" alt="" class="chat-icon" @click="chatNow(notification)">
                        <img src="/icon/chat_active.svg" alt="" class="chat-icon-active" @click="chatNow(notification)">
                        <span class="chat-text" @click="chatNow(notification)">{{ $t('chatNow') | capitalize }}</span>
                    </v-layout>
                </div>
            </div>
        </div>
        <v-layout class="action-container">
            <div class="group-action" @click="viewAll">
                {{ $t('viewAll') |capitalize }}
            </div>
            <div class="group-action" @click="markAllAsRead" :class="{disabled: notifies_data.length < 1}">
                {{ $t('markAllAsRead') |capitalize }}
            </div>
        </v-layout>
    </div>
</template>

<script>
import {mapState} from "vuex";
import UserService from "src/services/user.service";

export default {
    name: "NotificationGroup",
    computed: {
        ...mapState([
            'unreadUserNotifies',
            'chatView'
        ])
    },
    data () {
        return {
            show: false,
            typeFilter: 'all',
            typeList: [
                {text: this.$filters.capitalize(this.$t('notifyRequestSupport')), value: "user_request_support"},
                {text: this.$filters.capitalize(this.$t('notifyAssignedSupport')), value: "admin_assign_support"},
                {text: this.$filters.capitalize(this.$t('warning')), value: "warning"},
                {text: this.$filters.capitalize(this.$t('all')), value: null},
            ],
            notifies_data: []
        }
    },
    mounted () {
        this.$EventBus.$on(this.$EventBusType.NOTIFICATION_GROUP, this.toggle);
        this.getUnreadNotifies();
    },
    destroyed () {
        this.$EventBus.$off(this.$EventBusType.NOTIFICATION_GROUP, this.toggle);
    },
    methods: {
        getUnreadNotifies () {
            let type_filter = this.typeFilter === 'all' ? null : this.typeFilter;
            UserService.getLatestUserNotifies(type_filter).then(response => {
                this.$store.commit(this.$ActionTypes.GET_UNREAD_USER_NOTIFY, response.data)
            }).catch(e => {
                console.error("Get User Notify failed.");
                console.error(e);
            })
        },
        open () {
            this.show = true
        },
        close () {
            this.show = false
        },
        toggle (payload) {
            this.show = payload
        },
        chatNow (notification) {
            this.$EventBus.$emit(this.$EventBusType.NOTIFICATION_GROUP, false)
            let bot_code = notification.extra_data.bot_code,
                sender_id = notification.extra_data.sender_id;
            if (!notification.read_status) {
                UserService.callMarkAllAsRead([notification]);
                notification.read_status = true;
                this.unreadUserNotifies.total-=notification.count;
                notification.count = 0;
                if (this.unreadUserNotifies.total < 0) {
                    this.unreadUserNotifies.total = 0;
                }
            }
            if (!!bot_code && !!sender_id && (this.chatView.botCode !== bot_code || this.chatView.senderId !== sender_id)) {
                this.$router.push(`/bot/${bot_code}/s/${sender_id}`);
            }
        },
        viewAll () {
            this.$router.push('/notifications')
        },
        async markAllAsRead () {
            let confirm = await this.$appService.confirm(this.$t('markAllNotificationsAsReadConfirm'))
            if (!confirm){
                return
            }
            UserService.callMarkAllAsRead(this.notifies_data).then(() => {
                this.getUnreadNotifies();
            });
        },
        parseCount(count) {
            return count > 9 ? '9+' : count
        },
      format_notify_message(notify) {
          return UserService.format_notify_message(notify) || notify
      }
    },
    watch: {
        unreadUserNotifies() {
            if (!this.typeFilter || this.typeFilter === 'all') {
                this.notifies_data = this.unreadUserNotifies.data;
            } else {
                this.notifies_data = this.unreadUserNotifies.data.filter(notify => notify.type === this.typeFilter);
            }
        },
        typeFilter() {
            this.getUnreadNotifies();
        }
    },
}
</script>

<style scoped lang="scss">
    .NotificationBox {
        position: absolute;
        top: 60px;
        left: -100%;
        background: #fff;
        width: 100%;
        height: calc(100% - 60px);
        transition: all 0.4s ease;
        overflow: auto;
        display: flex;
        flex-direction: column;

        &.active {
            left: 0;
        }
    }

    .item-list {
        overflow: auto;
        height: calc(100% - 43px);
    }

    .action-container {
        color: #0052CC;
        padding: 11px;
        max-height: 43px;
    }

    .indicator {
        position: absolute;
        top: -8px;
        right: 73px;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 8px solid #fff;
    }

    .notification-item {
        display: flex;
        padding: 14px;
        box-shadow: 0 1px 0 #EDEDF2;

        &:hover {
            background: #F7F7FC;

            .chat-text {
                color: #0052CC;
            }

            .chat-icon {
                display: none;
            }

            .chat-icon-active {
                display: block;
            }
        }
    }

    .notification-circle {
        width: 10px;
        height: 10px;
        border-radius: 100%;
        margin: 7px 8px 0 0;
        background: #B2B4C6;

        &.active {
            background: #F7722F;
            &.admin_assign_support {
                background: #12B119;
            }
            &.user_request_support {
                background: #F72F2F;
            }
            &.notify-warning {
                background: #F7722F;
            }
        }

        &.big {
            width: 20px;
            height: 20px;
            text-align: center;
            color: white;
            position: relative;
            right: 6px;
            margin-right: 0px;
        }
    }

    .notification-text {
        margin-bottom: 10px;
        word-break: break-word;
    }

    .notification-time {
        color: #888A9A;
    }

    .chat-icon, .chat-icon-active {
        margin-right: 4px;
        cursor: pointer;
    }

    .chat-icon-active {
        display: none;
    }

    .chat-text {
        color: #888A9A;
        cursor: pointer;
    }

    .group-action {
        flex: 1 1 1px;
        text-align: center;
        cursor: pointer;

        &.disabled {
            pointer-events: none;
            opacity: 0.5;
        }
    }

    ::v-deep .tab-badge-2 .v-badge__badge{
        top: -0px !important;
    }
</style>
<style scoped lang="scss" src="../style/bot-view.scss"></style>
